<template>
    <layout name="LayoutDefault">
        <div class="About">


            <!-- Page Content -->
            <div class="container">
                <!-- Page Features -->
                <div class="contents">
                    <div class="row text-justify">

                        <div class="col-lg-12 ">

                            <p>Content coming soon...</p>


                        </div>

                    </div>

                </div>
            </div>
            <!-- /.container -->
        </div>
    </layout>
</template>

<script>
    import Layout from '../layouts/Layout';

    export default {
        name: `Home`,
        components: {
            Layout,
        },
    };
</script>
